// LIBRERIE/IMPORTS
import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface LoaderProps {
    agencyData: {
        agency_name: string;
    };
    isLoading: boolean;
}

export const Loader: React.FC<LoaderProps> = ({ agencyData, isLoading }) => {
    const { t } = useTranslation();

    const agencyName = agencyData.agency_name;
    const logoAltText = t('header.navbar.logoAltPattern', { agencyName });
    const logoTitleText = t('header.navbar.logoTitlePattern', { agencyName });
    const homeLinkTitle = t('navigation.homeLinkTitle');

    if (!isLoading) {
        return null;
    }

    return (
        <div id="site-loader" className="load-complete">
            <div className="load-position">
                <div className="logo logo-block">
                    <Link to="/" title={homeLinkTitle}>
                        <img
                            src="/assets/images/logo.png"
                            alt={logoAltText}
                            title={logoTitleText}
                        />
                    </Link>
                </div>
                <div className="loading">
                    <div className="loading-line"></div>
                    <div className="loading-break loading-dot-1"></div>
                    <div className="loading-break loading-dot-2"></div>
                    <div className="loading-break loading-dot-3"></div>
                </div>
            </div>
        </div>
    );
};


export default Loader;